module.exports = __webpack_public_path__ + "static/logo-f284ab3ed76821dc90a0459762047e90.png";